<script lang="ts">
  import { translate } from "lib";
  import { ButtonComponent, InputField } from "ui";

  let data: any;
  let hours = 16;
  let minutes = 0;

  const onSubmit = (): void => {
    data.executeFunction(+hours * 60 + (minutes ? +minutes : 0));
  };

  export { data };
</script>

<div class="p-4 flex flex-col gap-4">
  <div class="text-center font-semibold">
    {translate("HOW_LONG_DO_YOU_PLAN_TO_FAST_FOR")}?
  </div>

  <div class="flex items-center">
    <InputField type="number" suffix="h" bind:value={hours} />
    <div class="mx-2 text-xl font-semibold">:</div>
    <InputField type="number" suffix="m" bind:value={minutes} />
  </div>

  <div class="flex justify-center">
    <ButtonComponent on:click={onSubmit}>{translate("START")}</ButtonComponent>
  </div>
</div>
